<template lang="pug">
.loading(v-if="show")
  .content
    img(src="@/assets/svg/loading.svg", alt="alt")
    h3 処理中…
</template>

<script>
export default {
  name: "Loading",
  props: {
    show: {
      default: false,
      type: Boolean,
    },
  },
};
</script>

<style lang="scss">
.loading {
  width: 100vw;
  height: 100vh;
  background-color: rgba(248, 248, 248, 0.733);
  /* 以下のコードを追加 */
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  .content {
    padding-top: 30vh;
  }
}
</style>
